import React from "react";

import WindowWidth from "../../../hooks/WindowWidth";
import Heading from "../../../shared/Heading/Heading";
import InformationText from "../../../shared/InformationText/InformationText";
import EntertainmentsLogic from "../EntertainmentsLogic";
import EntertainmentPreview from "../../../components/EntertainmentPreview/EntertainmentPreview";
import LoadingContainer from "../../../shared/LoadingContainer/LoadingContainer";
import DaysList from "../../../components/DaysList/DaysList";
import EntertainmentFooter from "../../../components/Footer/EntertainmentFooter";

import styles from "./entertainments.module.css";
import Markdown from "markdown-to-jsx";

const EntertainmentMobile = ({ setView, showType }) => {
  const { isLoading, pageTextData, stayDates, entertainmentStaticContent } = EntertainmentsLogic(showType);
  const { width } = WindowWidth();

  return (
    <>
      {isLoading ? (
        <LoadingContainer />
      ) : (
        <div className={styles.entertainmentWrapper}>
          <div className={styles.entertainmentHeadline}>
            <div className={styles.entertainmentTitle}>
              <Heading
                txt={pageTextData?.MobileTitle}
                paddingTop={width >= 700 ? "40px" : "20px"}
                paddingBottom={"20px"}
                fontSize={"24px"}
                fontFamily="Georgia"
                textTransform="uppercase"
              />
              <div className={styles.information}>
                <InformationText
                  content={
                    pageTextData?.MobileDescription ? (
                      <Markdown>{pageTextData?.MobileDescription}</Markdown>
                    ) : null
                  }
                  lineHeight={"1.5rem"}
                />
              </div>
            </div>
          </div>
          <DaysList data={stayDates} setView={setView} view={showType} />
          <EntertainmentPreview stayDates={stayDates} width={width} entertainmentStaticContent={entertainmentStaticContent}/>

          <EntertainmentFooter
            dates={stayDates}
            setView={(v) => setView(v)}
            view={showType}
          />
        </div>
      )}
    </>
  );
};

export default EntertainmentMobile;
